import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ListItem, Typography } from '@material-ui/core';
import IndeterminateCheck from './IndeterminateCheck';

const useStyles = makeStyles(theme => ({
  typography: {
    padding: theme.spacing(0),
    fontSize: '16',
  },
  listItemText: {
    fontSize:'11pt',
  },
}));

export default function IndeterminateItem(props) {
  const classes = useStyles();

  return (
    <div>
      <ListItem 
        button 
        disableGutters
        alignItems="flex-start"
        style={{flexDirection: "row", justifyContent:"space-between"}}
      >
        <IndeterminateCheck key={props.link} />
        <div 
          style={{
            display: "flex", 
            flexDirection: "column", 
            justifyContent: "center", 
            flexGrow: 2 , 
            padding : '0.5em 0em 0em 0em'
          }}
        >
          <Typography className={classes.typography}>
            {"Article " + props.number + ":"}
          </Typography>
          <Typography className={classes.typography}>
            {props.link}
          </Typography>
        </div>
      </ListItem>
    </div>
  );
}

